import { ErrorMessage, Field } from "formik";

export const FilterToggleSwitch = ({
  name,
  label,
  labelClassName = "",
  wrapperClassName = "",
}) => {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div className={`flex items-center ${wrapperClassName} my-4 mx-1`}>
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              id={name}
              {...field}
              checked={field.value}
              className="sr-only peer"
            />
            <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-100 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
            {label && (
              <span
                className={`ms-3 text-sm font-medium text-black ${labelClassName}`}
              >
                {label}
              </span>
            )}
          </label>
          {meta.touched && meta.error && (
            <div className="text-errorColor text-sm ps-2">
              <ErrorMessage name={name} />
            </div>
          )}
        </div>
      )}
    </Field>
  );
};
